import { useState, useCallback } from 'react'
import type { ExportOptions } from '../types/history'
import { exportHistory } from '../services/history'

interface UseHistoryExportResult {
  exporting: boolean
  error: string | null
  exportHistory: (options: ExportOptions) => Promise<void>
}

export function useHistoryExport(caseId: string | undefined): UseHistoryExportResult {
  const [exporting, setExporting] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const triggerExport = useCallback(
    async (options: ExportOptions) => {
      if (!caseId) {
        return
      }

      setExporting(true)
      setError(null)

      try {
        await exportHistory(caseId, options)
      } catch (err) {
        setError(err instanceof Error ? err.message : 'Failed to export history')
      } finally {
        setExporting(false)
      }
    },
    [caseId]
  )

  return { exporting, error, exportHistory: triggerExport }
}
